<div>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>


  <div>

    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">


      <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmit()" novalidate="">
        <div class="block">
          <div class="col-14">
            <div class="row justify-content-around">

              <div class="col-10 ml-2">
                <div class="row justify-content-around">
                  <div class="col-6" [ngClass]="{'mt-4 pt-1': isNew}" *ngIf="conectiaLicence">
                    <app-dropdown-formularios *ngIf="this.isNew" dataSize="7" placeHolder="Centro"
                      (selectedValueChange)="workCenterSelectedChange($event)" [required]="true"
                      [dropdownType]="'InnuvaWorkCenter'" [companyData]="this.inputData.companyData"
                      [configuredWorkCenterCodes]="this.inputData.configuredWorkCenterCodes">
                    </app-dropdown-formularios>

                    <app-form-input-app *ngIf="!this.isNew" [labelText]="'Nombre'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text" readonly
                        [(ngModel)]="appAppWorkCentersModel.name" name="workCenterName" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-6" *ngIf="!conectiaLicence">
                    <app-form-input-app [labelText]="'Nombre'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text"
                        [(ngModel)]="appAppWorkCentersModel.name" name="workCenterName" required="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-lg-6 mt-4 pt-1">
                    <app-dropdown-formularios dataSize="7" placeHolder="Habilitado"
                      [selectedValue]="appAppWorkCentersModel.enabled.toString()"
                      (selectedValueChange)="enabledSelectedChange($event)" [required]="true" [dropdownType]="'YesNo'">
                    </app-dropdown-formularios>
                  </div>
                </div>

                <div class="row justify-content-around">
                  <div class="col-6 ">
                    <app-form-input-app [labelText]="'Empresa'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text"
                        [(ngModel)]="appAppWorkCentersModel.company" name="workCenterCompany" required="true"
                        [readOnly]="true">
                    </app-form-input-app>
                  </div>

                  <div class="col-lg-6 mt-4 pt-1">
                    <app-dropdown-formularios dataSize="7" placeHolder="Geolocalización"
                      [selectedValue]="appAppWorkCentersModel.geolocation.toString()"
                      (selectedValueChange)="enabledGeolocationChange($event)" [required]="true"
                      [dropdownType]="'YesNo'">
                    </app-dropdown-formularios>
                  </div>
                </div>

                <div class="row justify-content-around" *ngIf="appAppWorkCentersModel.geolocation">
                  <div class="col-6 ">
                    <app-form-input-app [labelText]="'Dirección'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text"
                        [(ngModel)]="appAppWorkCentersModel.address" name="workCenterAddress"
                        (ngModelChange)="onAddressChange($event)" required="true"
                        matTooltip="Se debe introducir formato: Calle, número, código postal"
                        matTooltipPosition="above">
                    </app-form-input-app>
                  </div>

                  <div class="col-6 ">
                    <app-form-input-app [labelText]="'Coordenadas'" [isRequired]="true">
                      <input class="form-control" autocomplete="off" type="text"
                        [(ngModel)]="appAppWorkCentersModel.coordinates" name="workCenterCoordinates"
                        (ngModelChange)="onCoordinatesChange($event)" required="true">
                    </app-form-input-app>
                  </div>
                </div>

                <div class="row justify-content-around" *ngIf="appAppWorkCentersModel.geolocation">
                  <div class="map-container mt-5">
  
                    <app-custom-map [center]="[center.lng, center.lat]"
                      (markerChanged)="addMarker({ location: $event })" [markerUrl]="markerUrl">
                    </app-custom-map>

                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
        <!-- Botonera -->
        <div class="row">
          <label class="col-md-3"></label>
          <div class="col-md-9">
            <div class="form-group form-button">
              <button class="btn btn-fill btn-primary float-right" type="submit"
                [disabled]="!appAppWorkCentersModel.name || (appAppWorkCentersModel.geolocation && (!appAppWorkCentersModel.address || !appAppWorkCentersModel.coordinates))">
                Guardar
              </button>
              <a class="btn btn-fill btn-outline-white float-right" (click)="closePopUp()">Volver</a>
            </div>
          </div>
        </div>
      </form>
    </app-generic-panel>

  </div>




</div>